// extracted by mini-css-extract-plugin
export default {"wrapper":"ydPA0","content":"_2roqK","title":"bp98F","description":"aj8Lm","note":"J2hFW","button":"pzJtG","buttonContent":"R1734","image":"g-OHF","skeleton-progress":"nkNnw"};